"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var H4 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H4",
  componentId: "sc-1fpprg-0"
})([""]);
H4.propTypes = _Heading.default.propTypes;
H4.defaultProps = Object.assign({}, _Heading.default.defaultProps, {
  tagName: 'h4'
});
H4.displayName = 'H4';
var _default = H4;
exports.default = _default;
module.exports = exports.default;